import React from "react";
import logoW from "../images/logoW.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { BsArrowLeftShort, BsSearch, BsCartFill, BsFillGridFill, BsFileArrowDown } from "react-icons/bs";
import { LanguageIcon } from "../services/common";
import symbolWhite from "../images/symbolWhite.svg";
import appDown from "../images/appDown.svg";

export default function Header(props){
    const locationNow = useLocation();
    const accessToken = localStorage.getItem("accessToken");

    let userInfo = {}
    if(localStorage.getItem("user")){
        userInfo =JSON.parse(localStorage.getItem("user")).data;
    }
        
    //뒤로가기
    const navigate = useNavigate();
    const handleBack = () => {
        if(props.handleBack){
            props.handleBack();
        }else{
            navigate(-1);
        }
        
    }

    const fn_download = () =>{
        const ua = navigator.userAgent.toLowerCase();
        window.location.href =
        ua.indexOf("android") > -1
          ? "https://play.google.com/store/apps/details?id=kr.co.salee&pcampaignid=web_share"
          : "https://apps.apple.com/us/app/salee-%EC%82%B4%EB%A6%AC/id6505046462";
    }


    if (props.type==='main') {
        return(
            <header>
                <ul className="headArea mainHA">
                    <li onClick={fn_download}>
                        <div  className="hdLink hlApp"><img src={appDown} alt="앱아이콘"/> <span>Salee App<br/>Download</span></div>
                    </li>
                    <li>
                        <h1 className="logo"><img src={logoW} alt="로고"/></h1>
                    </li>
                    <li>
                        { props.newItem ? 
                            (<Link to="/Cart" className="hdLink hlCart active"><BsCartFill/></Link>) :
                            (<Link to="/Cart" className="hdLink hlCart"><BsCartFill/></Link>) 
                        }
                        {userInfo.mberTy && userInfo.mberTy==='B'?(
                        <form name="ssoFrom" method="post" action="https://www.salee.co.kr/uat/uia/tknLogin.sale" className="hdForm">
                            <input type="hidden" name="returnUrl" value="/shop/broker/createOrderSheet.sale" />
                            <input type="hidden" name="token" value={accessToken} />
                            <button type="submit" className="hdLink asdf">대량주문</button>                        
                        </form>
                        ):null}
                    </li>
                </ul>
            </header>
        );
    } else if (props.type==='search') {
        return (
            <header>
                <ul className="headArea">
                    <li>
                        <button type="button" onClick={handleBack} className="hdBack"><BsArrowLeftShort /></button>
                        <p className="pageTitle">{props.pageTitle}</p>
                    </li>
                    <li>
                        <Link to="/" className="hdLink hlHome"><img src={symbolWhite} alt="symbol"/></Link>
                        <Link to="/Search" className="hdLink hlSearch"><BsSearch /></Link>
                        <Link to="/Language" className="hdLink hlLanguage kor">                        
                        {LanguageIcon()} 
                        </Link>
                    </li>
                </ul>
            </header>
        );
    } else if (props.type==='cart') {
        return (
            <header>
                <ul className="headArea">
                    <li>
                        <button type="button" onClick={handleBack} className="hdBack"><BsArrowLeftShort /></button>
                        <p className="pageTitle">{props.pageTitle}</p>
                    </li>
                    <li>
                        <Link to="/" className="hdLink hlHome"><img src={symbolWhite}/></Link>
                        { props.newItem ? 
                            (<Link to="/Cart" className="hdLink hlCart active"><BsCartFill/></Link>) :
                            (<Link to="/Cart" className="hdLink hlCart"><BsCartFill/></Link>) 
                        }
                        <Link to="/Language" className="hdLink hlLanguage kor"> {LanguageIcon()}</Link>
                    </li>
                </ul>
            </header>
        );
    } else if (props.type==='black') {
        return (
            <header>
                <ul className="headArea txtBlack">
                    <li>
                        <button type="button" onClick={handleBack} className="hdBack"><BsArrowLeftShort /></button>
                        <p className="pageTitle">{props.pageTitle}</p>
                    </li>
                </ul>
            </header>
        );
    } else if (props.type==='title') {
        return (
            <header>
                <ul className="headArea">
                    <li>
                        <button type="button" onClick={handleBack} className="hdBack"><BsArrowLeftShort /></button>
                        <p className="pageTitle">{props.pageTitle}</p>
                    </li>
                </ul>
            </header>
        );
    } else if (props.type==='modal') {
        return (
            <header>
                <ul className="headArea txtBlack">
                    <li>
                        <button type="button" onClick={ (e) =>  props.closeFn(false)} className="hdBack"><BsArrowLeftShort /></button>
                        <p className="pageTitle">{props.pageTitle}</p>
                    </li>
                </ul>
            </header>
        );
    } else if (props.type==='modal2') {
        return (
            <header>
                <ul className="headArea">
                    <li>
                        <button type="button" onClick={ (e) =>  props.closeFn(false)} className="hdBack"><BsArrowLeftShort /></button>
                        <p className="pageTitle">{props.pageTitle}</p>
                    </li>
                </ul>
            </header>
        );
    }
};


